import { Suspense } from 'react';

import { SocketProvider } from '@/components/socket-provider';
import { flagsHooks } from '@/hooks/flags-hooks';
import { platformHooks } from '@/hooks/platform-hooks';
import { projectHooks } from '@/hooks/project-hooks';

import { authenticationSession } from '../../lib/authentication-session';
import { LoadingScreen } from '@/components/ui/loading-screen';
import { redirectToSignIn } from '@/lib/auth-navigation';

type AllowOnlyLoggedInUserOnlyGuardProps = {
  children: React.ReactNode;
};
export const AllowOnlyLoggedInUserOnlyGuard = ({
  children,
}: AllowOnlyLoggedInUserOnlyGuardProps) => {
  if (!authenticationSession.isLoggedIn()) {
    redirectToSignIn();
    return null;
  }
  projectHooks.prefetchProject();
  platformHooks.prefetchPlatform();
  flagsHooks.useFlags();

  return (
    <Suspense fallback={<LoadingScreen></LoadingScreen>}>
      <SocketProvider>{children}</SocketProvider>
    </Suspense>
  );
};
